import React from "react"
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material"
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus"
import { useTranslation } from "providers/i18n"
import { deepmerge } from "@mui/utils"

export const BusListItem = ({
  icon = <DirectionsBusIcon />,
  sx = {},
  title,
  origin,
  destination,
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const styleOverrides = theme.components[`BusListItem`]?.styleOverrides || {}
  const { root, listItemIcon, titleText, originText, destinationText } =
    styleOverrides
  return (
    <>
      <ListItem sx={deepmerge(root, sx)} {...props}>
        <ListItemIcon sx={listItemIcon}>
          <DirectionsBusIcon fontSize="large" />
        </ListItemIcon>
        <ListItemText>
          <Typography variant="title" component="p" sx={titleText}>
            {t(title)}
          </Typography>
          <Typography variant="subtitle" component="p" sx={originText}>
            {t("Origin")}: {t(origin)}
          </Typography>
          <Typography variant="subtitle" component="p" sx={destinationText}>
            {t("Destination")}: {t(destination)}
          </Typography>
        </ListItemText>
      </ListItem>
    </>
  )
}
